import Localization from "../localization";

const storageKeys = {
  token: "token",
  userUuid: "userUuid",
  isSafelandMobileApp: "isSafelandMobileApp",
};

const paymentType = {
  card: 0,
  invoice: 1,
  activation: 2,
};

const serviceType = {
  connect: "connect-homes-se",
  connectPlus: "connect-plus-se",
};

const deviceTypes = {
  verisure: 101,
  ajax: 120,
  sikkerthjem: 119,
  yoyoCam3gIndoor: 104,
  nestProtect: 10002,
  point: 10008,
  visonicPowerMaster10: 100,
  http: 10000,
  sms: 10002,
  other: 99999,
};

const deviceIntegrations = {
  http: "http",
  sms: "sms",
  ajax: "ajax",
  verisure: "verisure",
};

const webhookSignals = {
  alarm: "alarm",
  cancel: "cancel",
  arm: "arm",
  disarm: "disarm",
  night: "night",
};
const webhookMethods = {
  get: "GET",
  post: "POST",
};

const serviceCardIDs = {
  smhi: "smhi",
  connect: "connect",
  location: "location",
  alarmSms: "alarm_sms",
  alarmCentral: "alarm_central",
  alarmConnection: "alarm_connection",
  subscriptionStatus: "subscription_status",
};

const arcActionTypes = {
  burglary: "burglary",
  fire: "fire",
  fight: "fight",
  emergency: "emergency",
  sabotage: "sabotage",
  tech: "tech",
};

const alarmSMScategories = {
  burglary: "burglary",
  fire: "fire",
  emergency: "emergency",
  water: "flood",
};

const pagesNames = {
  purchaseSubscription: "purchase-subscription",
  otherDevice: "other-device",
  servicePaymentPlans: "service-payment-plans",
  subscription: "subscription",
  feedback: "feedback",
  resetPassword: "resetpassword",
  activate: "activate",
};

const subscriptionState = {
  ok: "ok",
  error: "error",
  unConfigured: "unconfigured",
};

const data = {
  [serviceType.connect]: { name: Localization.general.connect },
  [serviceType.connectPlus]: { name: Localization.general.connect_plus },
  [webhookSignals.alarm]: { name: Localization.general.alarm_triggered },
  [webhookSignals.cancel]: { name: Localization.general.alarm_ended },
  [webhookSignals.arm]: { name: Localization.general.system_activated },
  [webhookSignals.disarm]: { name: Localization.general.system_deactivated },
  [webhookSignals.night]: { name: Localization.general.night_mode_activated },
  [arcActionTypes.burglary]: {
    title: Localization.general.burglary,
    defaultAction: "4",
  },
  [arcActionTypes.fire]: {
    title: Localization.general.fire,
    defaultAction: "4",
  },
  [arcActionTypes.fight]: {
    title: Localization.general.fight,
    defaultAction: "0",
  },
  [arcActionTypes.emergency]: {
    title: Localization.general.emergency,
    defaultAction: "4",
  },
  [arcActionTypes.sabotage]: {
    title: Localization.general.sabotage,
    defaultAction: "4",
  },
  [arcActionTypes.tech]: {
    title: Localization.general.tech,
    defaultAction: "0",
  },
  alarmSMScategories: {
    [alarmSMScategories.burglary]: {
      name: Localization.general.burglary_alarm,
    },
    [alarmSMScategories.fire]: { name: Localization.general.fire_alarm },
    [alarmSMScategories.water]: { name: Localization.general.water_alarm },
    [alarmSMScategories.emergency]: {
      name: Localization.general.emergency_alarm,
    },
  },
};

const Enums = {
  pagesNames,
  storageKeys,
  paymentType,
  serviceType,
  deviceTypes,
  webhookSignals,
  webhookMethods,
  serviceCardIDs,
  arcActionTypes,
  deviceIntegrations,
  alarmSMScategories,
  subscriptionState,
  details: (key = "", key2 = "") => (!!key2 ? data[key][key2] : data[key]),
};

export default Enums;
